import "core-js/modules/es.array.push.js";
import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-087139fa"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "font-size": "10px",
    "display": "flex",
    "justify-content": "center",
    "align-items": "center",
    "height": "18px"
  }
}, "颜色开关：", -1));
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "font-size": "10px",
    "display": "flex",
    "justify-content": "center",
    "align-items": "center",
    "height": "18px"
  }
}, "(所有数据均同初盘对比)", -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "contentWater"
}, "时间 ", -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "contentWater"
}, "0球 ", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "contentWater"
}, "1球 ", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "contentWater"
}, "2球 ", -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "contentWater"
}, "3球 ", -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "contentWater"
}, "4球 ", -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "contentWater"
}, "5球 ", -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "contentWater"
}, "6+球 ", -1));
const _hoisted_11 = {
  class: "contentWater"
};
const _hoisted_12 = {
  class: "contentWater"
};
const _hoisted_13 = {
  class: "contentWater"
};
const _hoisted_14 = {
  class: "contentWater"
};
const _hoisted_15 = {
  class: "contentWater"
};
const _hoisted_16 = {
  class: "contentWater"
};
const _hoisted_17 = {
  class: "contentWater"
};
const _hoisted_18 = {
  class: "contentWater"
};
const _hoisted_19 = {
  class: "contentWater"
};
const _hoisted_20 = {
  key: 0,
  class: "contentWaterRed"
};
const _hoisted_21 = {
  key: 1,
  class: "contentWaterGreen"
};
const _hoisted_22 = {
  key: 2,
  class: "contentWater"
};
const _hoisted_23 = {
  key: 0,
  class: "contentWaterRed"
};
const _hoisted_24 = {
  key: 1,
  class: "contentWaterGreen"
};
const _hoisted_25 = {
  key: 2,
  class: "contentWater"
};
const _hoisted_26 = {
  key: 0,
  class: "contentWaterRed"
};
const _hoisted_27 = {
  key: 1,
  class: "contentWaterGreen"
};
const _hoisted_28 = {
  key: 2,
  class: "contentWater"
};
const _hoisted_29 = {
  key: 0,
  class: "contentWaterRed"
};
const _hoisted_30 = {
  key: 1,
  class: "contentWaterGreen"
};
const _hoisted_31 = {
  key: 2,
  class: "contentWater"
};
const _hoisted_32 = {
  key: 0,
  class: "contentWaterRed"
};
const _hoisted_33 = {
  key: 1,
  class: "contentWaterGreen"
};
const _hoisted_34 = {
  key: 2,
  class: "contentWater"
};
const _hoisted_35 = {
  key: 0,
  class: "contentWaterRed"
};
const _hoisted_36 = {
  key: 1,
  class: "contentWaterGreen"
};
const _hoisted_37 = {
  key: 2,
  class: "contentWater"
};
const _hoisted_38 = {
  key: 0,
  class: "contentWaterRed"
};
const _hoisted_39 = {
  key: 1,
  class: "contentWaterGreen"
};
const _hoisted_40 = {
  key: 2,
  class: "contentWater"
};
const _hoisted_41 = {
  class: "contentWater"
};
const _hoisted_42 = {
  key: 0,
  class: "contentWaterRed"
};
const _hoisted_43 = {
  key: 1,
  class: "contentWaterGreen"
};
const _hoisted_44 = {
  key: 2,
  class: "contentWater"
};
const _hoisted_45 = {
  key: 0,
  class: "contentWaterRed"
};
const _hoisted_46 = {
  key: 1,
  class: "contentWaterGreen"
};
const _hoisted_47 = {
  key: 2,
  class: "contentWater"
};
const _hoisted_48 = {
  key: 0,
  class: "contentWaterRed"
};
const _hoisted_49 = {
  key: 1,
  class: "contentWaterGreen"
};
const _hoisted_50 = {
  key: 2,
  class: "contentWater"
};
const _hoisted_51 = {
  key: 0,
  class: "contentWaterRed"
};
const _hoisted_52 = {
  key: 1,
  class: "contentWaterGreen"
};
const _hoisted_53 = {
  key: 2,
  class: "contentWater"
};
const _hoisted_54 = {
  key: 0,
  class: "contentWaterRed"
};
const _hoisted_55 = {
  key: 1,
  class: "contentWaterGreen"
};
const _hoisted_56 = {
  key: 2,
  class: "contentWater"
};
const _hoisted_57 = {
  key: 0,
  class: "contentWaterRed"
};
const _hoisted_58 = {
  key: 1,
  class: "contentWaterGreen"
};
const _hoisted_59 = {
  key: 2,
  class: "contentWater"
};
const _hoisted_60 = {
  key: 0,
  class: "contentWaterRed"
};
const _hoisted_61 = {
  key: 1,
  class: "contentWaterGreen"
};
const _hoisted_62 = {
  key: 2,
  class: "contentWater"
};
const _hoisted_63 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_64 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "contentWater"
}, "盘口 ", -1));
const _hoisted_65 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "contentWater"
}, "0.5 ", -1));
const _hoisted_66 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "contentWater"
}, "1.5 ", -1));
const _hoisted_67 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "contentWater"
}, "2.5 ", -1));
const _hoisted_68 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "contentWater"
}, "3.5 ", -1));
const _hoisted_69 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "contentWater"
}, "4.5 ", -1));
const _hoisted_70 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "contentWater"
}, "初盘 ", -1));
const _hoisted_71 = {
  key: 0,
  class: "contentWaterRed"
};
const _hoisted_72 = {
  key: 1,
  class: "contentWaterGreen"
};
const _hoisted_73 = {
  key: 2,
  class: "contentWater"
};
const _hoisted_74 = {
  key: 0,
  class: "contentWaterRed"
};
const _hoisted_75 = {
  key: 1,
  class: "contentWaterGreen"
};
const _hoisted_76 = {
  key: 2,
  class: "contentWater"
};
const _hoisted_77 = {
  key: 0,
  class: "contentWaterRed"
};
const _hoisted_78 = {
  key: 1,
  class: "contentWaterGreen"
};
const _hoisted_79 = {
  key: 2,
  class: "contentWater"
};
const _hoisted_80 = {
  key: 0,
  class: "contentWaterRed"
};
const _hoisted_81 = {
  key: 1,
  class: "contentWaterGreen"
};
const _hoisted_82 = {
  key: 2,
  class: "contentWater"
};
const _hoisted_83 = {
  key: 0,
  class: "contentWaterRed"
};
const _hoisted_84 = {
  key: 1,
  class: "contentWaterGreen"
};
const _hoisted_85 = {
  key: 2,
  class: "contentWater"
};
const _hoisted_86 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "contentWater"
}, "终盘 ", -1));
const _hoisted_87 = {
  key: 0,
  class: "contentWaterRed"
};
const _hoisted_88 = {
  key: 1,
  class: "contentWaterGreen"
};
const _hoisted_89 = {
  key: 2,
  class: "contentWater"
};
const _hoisted_90 = {
  key: 0,
  class: "contentWaterRed"
};
const _hoisted_91 = {
  key: 1,
  class: "contentWaterGreen"
};
const _hoisted_92 = {
  key: 2,
  class: "contentWater"
};
const _hoisted_93 = {
  key: 0,
  class: "contentWaterRed"
};
const _hoisted_94 = {
  key: 1,
  class: "contentWaterGreen"
};
const _hoisted_95 = {
  key: 2,
  class: "contentWater"
};
const _hoisted_96 = {
  key: 0,
  class: "contentWaterRed"
};
const _hoisted_97 = {
  key: 1,
  class: "contentWaterGreen"
};
const _hoisted_98 = {
  key: 2,
  class: "contentWater"
};
const _hoisted_99 = {
  key: 0,
  class: "contentWaterRed"
};
const _hoisted_100 = {
  key: 1,
  class: "contentWaterGreen"
};
const _hoisted_101 = {
  key: 2,
  class: "contentWater"
};
const _hoisted_102 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "contentWater"
}, "走势 ", -1));
const _hoisted_103 = {
  class: "contentWater"
};
const _hoisted_104 = {
  class: "contentWater"
};
const _hoisted_105 = {
  class: "contentWater"
};
const _hoisted_106 = {
  class: "contentWater"
};
const _hoisted_107 = {
  class: "contentWater"
};
import { h, ref } from 'vue';
import { getCrsToTtgConvert, count, decryptData } from './calculation.js';
import axios from 'axios';
import LoadingView from './LoadingView.vue';
import { useStore } from 'vuex';
import TtgBJ from './TtgBJ.vue';
export default {
  __name: 'CrsConvert',
  setup(__props, {
    expose: __expose
  }) {
    const store = useStore();
    const phonenumber = ref(store.state.user.phonenumber);
    const crsList = ref([]);
    const ttgConvert = ref({});
    const initTtgConvert = ref({});
    const matchWater = ref({});
    const initMatchWater = ref({});
    const level = ref(1.88);
    const obj = ref({});
    const id = ref({});
    const modalRef = ref(null);
    const infoValue = ref({});
    const listFlag = ref(false);
    const waterList = ref([]);
    const waterTtgList = ref([]);
    const waterCrsList = ref([]);
    const colorFlag = ref(true);
    const crsFlag = ref(false);
    const clickInfo = () => {
      modalRef.value.show(ttgConvert.value, 1);
    };
    const crsChange = value => {
      if (value) {
        getInitMatchGoalWater(waterCrsList.value[0], waterCrsList.value[waterCrsList.value.length - 1], waterTtgList.value[0], waterTtgList.value[waterTtgList.value.length - 1]);
      } else {
        getInitMatchGoalWater(waterList.value[0], waterList.value[waterList.value.length - 1], waterTtgList.value[0], waterTtgList.value[waterTtgList.value.length - 1]);
      }
    };
    const pushCrsList = (list, matchId, waterList1, waterList2, waterList3, value) => {
      crsList.value = list;
      id.value = matchId;
      infoValue.value = value;
      waterList.value = waterList1;
      waterTtgList.value = waterList2;
      waterCrsList.value = waterList3;
      getInitMatchGoalWater(waterList1[0], waterList1[waterList1.length - 1], waterList2[0], waterList2[waterList2.length - 1]);
      let columnsT = [];
      let name;
      let ttg;
      for (let i = 0; i < list.length; i++) {
        ttg = list[i];
        name = list[i].updateDate + "  " + list[i].updateTime;
        columnsT.push({
          text: name,
          value: name,
          obj: list[i],
          ttgSize: i
        });
      }
      obj.value = ttg;
      columns.value = columnsT;
      val.value = [name];
    };
    const loadingRef = ref(null);
    const getInitMatchGoalWater = async (waterInit, waterFast, waterTtgInit, waterTtgFast) => {
      try {
        //loadingRef.value.show();
        let data1 = waterInit;
        initMatchWater.value = data1;
        initTtgConvert.value = {
          Up05: data1.crsUp05,
          Down05: count(level.value, data1.crsUp05, '-'),
          Up15: data1.crsUp15,
          Down15: count(level.value, data1.crsUp15, '-'),
          Up25: data1.crsUp25,
          Down25: count(level.value, data1.crsUp25, '-'),
          Up35: data1.crsUp35,
          Down35: count(level.value, data1.crsUp35, '-'),
          Up45: data1.crsUp45,
          Down45: count(level.value, data1.crsUp45, '-'),
          Upttg05: waterTtgInit.ttgUp05,
          Upttg15: waterTtgInit.ttgUp15,
          Upttg25: waterTtgInit.ttgUp25,
          Upttg35: waterTtgInit.ttgUp35,
          Upttg45: waterTtgInit.ttgUp45
        };
        let data = waterFast;
        matchWater.value = data;
        ttgConvert.value = {
          Up05: data.crsUp05,
          Up05Rate: count(count(data.crsUp05, initTtgConvert.value.Up05, "-"), initTtgConvert.value.Up05, '/'),
          Down05: count(level.value, data.crsUp05, '-'),
          Up15: data.crsUp15,
          Up15Rate: count(count(data.crsUp15, initTtgConvert.value.Up15, "-"), initTtgConvert.value.Up15, '/'),
          Down15: count(level.value, data.crsUp15, '-'),
          Up25: data.crsUp25,
          Up25Rate: count(count(data.crsUp25, initTtgConvert.value.Up25, "-"), initTtgConvert.value.Up25, '/'),
          Down25: count(level.value, data.crsUp25, '-'),
          Up35: data.crsUp35,
          Up35Rate: count(count(data.crsUp35, initTtgConvert.value.Up35, "-"), initTtgConvert.value.Up35, '/'),
          Down35: count(level.value, data.crsUp35, '-'),
          Up45: data.crsUp45,
          Up45Rate: count(count(data.crsUp45, initTtgConvert.value.Up45, "-"), initTtgConvert.value.Up45, '/'),
          Down45: count(level.value, data.crsUp45, '-'),
          Upttg05: waterTtgFast.ttgUp05,
          Upttg15: waterTtgFast.ttgUp15,
          Upttg25: waterTtgFast.ttgUp25,
          Upttg35: waterTtgFast.ttgUp35,
          Upttg45: waterTtgFast.ttgUp45
        };
        //loadingRef.value.close();
      } catch (error) {
        // 处理错误
        console.error(error);
        //loadingRef.value.close();
      }
    };
    const refreshList = () => {
      listFlag.value = !listFlag.value;
    };
    const getMatchGoalWater = async (matchId, ttgSize) => {
      try {
        loadingRef.value.show();
        const response = await axios.post('https://tuhaojie.asia/api-foot/matchGoalWater/getMatchGoalWater?crsSize=' + ttgSize, infoValue.value);
        let data = decryptData(response.data);
        matchWater.value = data;
        ttgConvert.value = {
          Up05: data.crsUp05,
          Up05Rate: count(count(data.crsUp05, initTtgConvert.value.Up05, "-"), initTtgConvert.value.Up05, '/'),
          Down05: count(level.value, data.crsUp05, '-'),
          Up15: data.crsUp15,
          Up15Rate: count(count(data.crsUp15, initTtgConvert.value.Up15, "-"), initTtgConvert.value.Up15, '/'),
          Down15: count(level.value, data.crsUp15, '-'),
          Up25: data.crsUp25,
          Up25Rate: count(count(data.crsUp25, initTtgConvert.value.Up25, "-"), initTtgConvert.value.Up25, '/'),
          Down25: count(level.value, data.crsUp25, '-'),
          Up35: data.crsUp35,
          Up35Rate: count(count(data.crsUp35, initTtgConvert.value.Up35, "-"), initTtgConvert.value.Up35, '/'),
          Down35: count(level.value, data.crsUp35, '-'),
          Up45: data.crsUp45,
          Up45Rate: count(count(data.crsUp45, initTtgConvert.value.Up45, "-"), initTtgConvert.value.Up45, '/'),
          Down45: count(level.value, data.crsUp45, '-')
        };
        loadingRef.value.close();
      } catch (error) {
        // 处理错误
        console.error(error);
        loadingRef.value.close();
      }
    };
    const val = ref('');
    const columns = ref([]);
    const confirm = ({
      selectedValue,
      selectedOptions
    }) => {
      try {
        //ttgConvert.value = getCrsToTtgConvert(selectedOptions[0].obj, level.value);
        getMatchGoalWater(id.value, selectedOptions[0].ttgSize);
        obj.value = selectedOptions[0].obj;
      } catch (e) {}
    };
    const updateLevel = val => {
      try {
        ttgConvert.value = getCrsToTtgConvert(obj.value, val);
      } catch (e) {}
    };

    // 暴露给外部使用的函数
    __expose({
      pushCrsList
    });
    return (_ctx, _cache) => {
      const _component_nut_divider = _resolveComponent("nut-divider");
      const _component_nut_col = _resolveComponent("nut-col");
      const _component_var_switch = _resolveComponent("var-switch");
      const _component_nut_row = _resolveComponent("nut-row");
      const _component_var_col = _resolveComponent("var-col");
      const _component_var_row = _resolveComponent("var-row");
      const _component_nut_trend_arrow = _resolveComponent("nut-trend-arrow");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(TtgBJ, {
        ref_key: "modalRef",
        ref: modalRef
      }, null, 512), _createVNode(LoadingView, {
        ref_key: "loadingRef",
        ref: loadingRef
      }, null, 512), _createVNode(_component_nut_divider, {
        "content-position": "left",
        style: {
          margin: '8px 0'
        }
      }, {
        default: _withCtx(() => [_createTextVNode("比分转进球数计算器")]),
        _: 1
      }), _createVNode(_component_nut_row, null, {
        default: _withCtx(() => [_createVNode(_component_nut_col, {
          span: 4
        }, {
          default: _withCtx(() => [_hoisted_1]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 4
        }, {
          default: _withCtx(() => [_createVNode(_component_var_switch, {
            size: "10",
            modelValue: colorFlag.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => colorFlag.value = $event)
          }, null, 8, ["modelValue"]), phonenumber.value == '15705840617' ? (_openBlock(), _createBlock(_component_var_switch, {
            key: 0,
            size: "10",
            modelValue: crsFlag.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => crsFlag.value = $event),
            onChange: crsChange
          }, null, 8, ["modelValue"])) : _createCommentVNode("", true)]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 16
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_nut_row, null, {
        default: _withCtx(() => [_createVNode(_component_nut_col, {
          span: 3
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 3
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 3
        }, {
          default: _withCtx(() => [_hoisted_5]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 3
        }, {
          default: _withCtx(() => [_hoisted_6]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 3
        }, {
          default: _withCtx(() => [_hoisted_7]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 3
        }, {
          default: _withCtx(() => [_hoisted_8]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 3
        }, {
          default: _withCtx(() => [_hoisted_9]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 3
        }, {
          default: _withCtx(() => [_hoisted_10]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_nut_row, null, {
        default: _withCtx(() => [_createVNode(_component_nut_col, {
          span: 3
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_11, _toDisplayString(initMatchWater.value.crsTime), 1)]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 3
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_12, _toDisplayString(initMatchWater.value.crsS0), 1)]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 3
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_13, _toDisplayString(initMatchWater.value.crsS1), 1)]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 3
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_14, _toDisplayString(initMatchWater.value.crsS2), 1)]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 3
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_15, _toDisplayString(initMatchWater.value.crsS3), 1)]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 3
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_16, _toDisplayString(initMatchWater.value.crsS4), 1)]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 3
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_17, _toDisplayString(initMatchWater.value.crsS5), 1)]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 3
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_18, _toDisplayString(initMatchWater.value.crsS6), 1)]),
          _: 1
        })]),
        _: 1
      }), listFlag.value ? (_openBlock(true), _createElementBlock(_Fragment, {
        key: 0
      }, _renderList(crsFlag.value ? waterCrsList.value : waterList.value, (change, index) => {
        return _openBlock(), _createBlock(_component_nut_row, {
          key: index
        }, {
          default: _withCtx(() => [index != 0 && index != waterList.value.length - 1 ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_createVNode(_component_nut_col, {
            span: 3
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_19, _toDisplayString(change.crsTime), 1)]),
            _: 2
          }, 1024), _createVNode(_component_nut_col, {
            span: 3
          }, {
            default: _withCtx(() => [change.crsS0 > initMatchWater.value.crsS0 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(change.crsS0), 1)) : change.crsS0 < initMatchWater.value.crsS0 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(change.crsS0), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(change.crsS0), 1))]),
            _: 2
          }, 1024), _createVNode(_component_nut_col, {
            span: 3
          }, {
            default: _withCtx(() => [change.crsS1 > initMatchWater.value.crsS1 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(change.crsS1), 1)) : change.crsS1 < initMatchWater.value.crsS1 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(change.crsS1), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(change.crsS1), 1))]),
            _: 2
          }, 1024), _createVNode(_component_nut_col, {
            span: 3
          }, {
            default: _withCtx(() => [change.crsS2 > initMatchWater.value.crsS2 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(change.crsS2), 1)) : change.crsS2 < initMatchWater.value.crsS2 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(change.crsS2), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(change.crsS2), 1))]),
            _: 2
          }, 1024), _createVNode(_component_nut_col, {
            span: 3
          }, {
            default: _withCtx(() => [change.crsS3 > initMatchWater.value.crsS3 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(change.crsS3), 1)) : change.crsS3 < initMatchWater.value.crsS3 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(change.crsS3), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(change.crsS3), 1))]),
            _: 2
          }, 1024), _createVNode(_component_nut_col, {
            span: 3
          }, {
            default: _withCtx(() => [change.crsS4 > initMatchWater.value.crsS4 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_32, _toDisplayString(change.crsS4), 1)) : change.crsS4 < initMatchWater.value.crsS4 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString(change.crsS4), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_34, _toDisplayString(change.crsS4), 1))]),
            _: 2
          }, 1024), _createVNode(_component_nut_col, {
            span: 3
          }, {
            default: _withCtx(() => [change.crsS5 > initMatchWater.value.crsS5 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString(change.crsS5), 1)) : change.crsS5 < initMatchWater.value.crsS5 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString(change.crsS5), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_37, _toDisplayString(change.crsS5), 1))]),
            _: 2
          }, 1024), _createVNode(_component_nut_col, {
            span: 3
          }, {
            default: _withCtx(() => [change.crsS6 > initMatchWater.value.crsS6 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString(change.crsS6), 1)) : change.crsS6 < initMatchWater.value.crsS6 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_39, _toDisplayString(change.crsS6), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_40, _toDisplayString(change.crsS6), 1))]),
            _: 2
          }, 1024)], 64)) : _createCommentVNode("", true)]),
          _: 2
        }, 1024);
      }), 128)) : _createCommentVNode("", true), _createVNode(_component_nut_row, null, {
        default: _withCtx(() => [_createVNode(_component_nut_col, {
          span: 3
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_41, _toDisplayString(matchWater.value.crsTime), 1)]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 3
        }, {
          default: _withCtx(() => [matchWater.value.crsS0 > initMatchWater.value.crsS0 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_42, _toDisplayString(matchWater.value.crsS0), 1)) : matchWater.value.crsS0 < initMatchWater.value.crsS0 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_43, _toDisplayString(matchWater.value.crsS0), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_44, _toDisplayString(matchWater.value.crsS0), 1))]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 3
        }, {
          default: _withCtx(() => [matchWater.value.crsS1 > initMatchWater.value.crsS1 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_45, _toDisplayString(matchWater.value.crsS1), 1)) : matchWater.value.crsS1 < initMatchWater.value.crsS1 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_46, _toDisplayString(matchWater.value.crsS1), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_47, _toDisplayString(matchWater.value.crsS1), 1))]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 3
        }, {
          default: _withCtx(() => [matchWater.value.crsS2 > initMatchWater.value.crsS2 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_48, _toDisplayString(matchWater.value.crsS2), 1)) : matchWater.value.crsS2 < initMatchWater.value.crsS2 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_49, _toDisplayString(matchWater.value.crsS2), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_50, _toDisplayString(matchWater.value.crsS2), 1))]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 3
        }, {
          default: _withCtx(() => [matchWater.value.crsS3 > initMatchWater.value.crsS3 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_51, _toDisplayString(matchWater.value.crsS3), 1)) : matchWater.value.crsS3 < initMatchWater.value.crsS3 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_52, _toDisplayString(matchWater.value.crsS3), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_53, _toDisplayString(matchWater.value.crsS3), 1))]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 3
        }, {
          default: _withCtx(() => [matchWater.value.crsS4 > initMatchWater.value.crsS4 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_54, _toDisplayString(matchWater.value.crsS4), 1)) : matchWater.value.crsS4 < initMatchWater.value.crsS4 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_55, _toDisplayString(matchWater.value.crsS4), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_56, _toDisplayString(matchWater.value.crsS4), 1))]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 3
        }, {
          default: _withCtx(() => [matchWater.value.crsS5 > initMatchWater.value.crsS5 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_57, _toDisplayString(matchWater.value.crsS5), 1)) : matchWater.value.crsS5 < initMatchWater.value.crsS5 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_58, _toDisplayString(matchWater.value.crsS5), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_59, _toDisplayString(matchWater.value.crsS5), 1))]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 3
        }, {
          default: _withCtx(() => [matchWater.value.crsS6 > initMatchWater.value.crsS6 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_60, _toDisplayString(matchWater.value.crsS6), 1)) : matchWater.value.crsS6 < initMatchWater.value.crsS6 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_61, _toDisplayString(matchWater.value.crsS6), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_62, _toDisplayString(matchWater.value.crsS6), 1))]),
          _: 1
        })]),
        _: 1
      }), waterList.value.length > 2 ? (_openBlock(), _createBlock(_component_var_row, {
        key: 1
      }, {
        default: _withCtx(() => [_createVNode(_component_var_col, {
          span: 24
        }, {
          default: _withCtx(() => [_createElementVNode("div", {
            class: "refresh",
            onClick: refreshList
          }, [!listFlag.value ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_createTextVNode("点击加载更多历史数据")], 64)) : _createCommentVNode("", true), listFlag.value ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_createTextVNode("点击收起历史数据")], 64)) : _createCommentVNode("", true)])]),
          _: 1
        })]),
        _: 1
      })) : _createCommentVNode("", true), _hoisted_63, _createVNode(_component_nut_row, null, {
        default: _withCtx(() => [_createVNode(_component_nut_col, {
          span: 4
        }, {
          default: _withCtx(() => [_hoisted_64]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 4
        }, {
          default: _withCtx(() => [_hoisted_65]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 4
        }, {
          default: _withCtx(() => [_hoisted_66]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 4
        }, {
          default: _withCtx(() => [_hoisted_67]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 4
        }, {
          default: _withCtx(() => [_hoisted_68]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 4
        }, {
          default: _withCtx(() => [_hoisted_69]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_nut_row, null, {
        default: _withCtx(() => [_createVNode(_component_nut_col, {
          span: 4
        }, {
          default: _withCtx(() => [_hoisted_70]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 4
        }, {
          default: _withCtx(() => [initTtgConvert.value.Up05 > initTtgConvert.value.Upttg05 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_71, _toDisplayString(initTtgConvert.value.Up05), 1)) : initTtgConvert.value.Up05 < initTtgConvert.value.Upttg05 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_72, _toDisplayString(initTtgConvert.value.Up05), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_73, _toDisplayString(initTtgConvert.value.Up05), 1))]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 4
        }, {
          default: _withCtx(() => [initTtgConvert.value.Up15 > initTtgConvert.value.Upttg15 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_74, _toDisplayString(initTtgConvert.value.Up15), 1)) : initTtgConvert.value.Up15 < initTtgConvert.value.Upttg15 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_75, _toDisplayString(initTtgConvert.value.Up15), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_76, _toDisplayString(initTtgConvert.value.Up15), 1))]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 4
        }, {
          default: _withCtx(() => [initTtgConvert.value.Up25 > initTtgConvert.value.Upttg25 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_77, _toDisplayString(initTtgConvert.value.Up25), 1)) : initTtgConvert.value.Up25 < initTtgConvert.value.Upttg25 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_78, _toDisplayString(initTtgConvert.value.Up25), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_79, _toDisplayString(initTtgConvert.value.Up25), 1))]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 4
        }, {
          default: _withCtx(() => [initTtgConvert.value.Up35 > initTtgConvert.value.Upttg35 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_80, _toDisplayString(initTtgConvert.value.Up35), 1)) : initTtgConvert.value.Up35 < initTtgConvert.value.Upttg35 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_81, _toDisplayString(initTtgConvert.value.Up35), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_82, _toDisplayString(initTtgConvert.value.Up35), 1))]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 4
        }, {
          default: _withCtx(() => [initTtgConvert.value.Up45 > initTtgConvert.value.Upttg45 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_83, _toDisplayString(initTtgConvert.value.Up45), 1)) : initTtgConvert.value.Up45 < initTtgConvert.value.Upttg45 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_84, _toDisplayString(initTtgConvert.value.Up45), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_85, _toDisplayString(initTtgConvert.value.Up45), 1))]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_nut_row, null, {
        default: _withCtx(() => [_createVNode(_component_nut_col, {
          span: 4
        }, {
          default: _withCtx(() => [_hoisted_86]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 4
        }, {
          default: _withCtx(() => [ttgConvert.value.Up05 > ttgConvert.value.Upttg05 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_87, _toDisplayString(ttgConvert.value.Up05), 1)) : ttgConvert.value.Up05 < ttgConvert.value.Upttg05 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_88, _toDisplayString(ttgConvert.value.Up05), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_89, _toDisplayString(ttgConvert.value.Up05), 1))]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 4
        }, {
          default: _withCtx(() => [ttgConvert.value.Up15 > ttgConvert.value.Upttg15 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_90, _toDisplayString(ttgConvert.value.Up15), 1)) : ttgConvert.value.Up15 < ttgConvert.value.Upttg15 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_91, _toDisplayString(ttgConvert.value.Up15), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_92, _toDisplayString(ttgConvert.value.Up15), 1))]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 4
        }, {
          default: _withCtx(() => [ttgConvert.value.Up25 > ttgConvert.value.Upttg25 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_93, _toDisplayString(ttgConvert.value.Up25), 1)) : ttgConvert.value.Up25 < ttgConvert.value.Upttg25 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_94, _toDisplayString(ttgConvert.value.Up25), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_95, _toDisplayString(ttgConvert.value.Up25), 1))]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 4
        }, {
          default: _withCtx(() => [ttgConvert.value.Up35 > ttgConvert.value.Upttg35 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_96, _toDisplayString(ttgConvert.value.Up35), 1)) : ttgConvert.value.Up35 < ttgConvert.value.Upttg35 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_97, _toDisplayString(ttgConvert.value.Up35), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_98, _toDisplayString(ttgConvert.value.Up35), 1))]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 4
        }, {
          default: _withCtx(() => [ttgConvert.value.Up45 > ttgConvert.value.Upttg45 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_99, _toDisplayString(ttgConvert.value.Up45), 1)) : ttgConvert.value.Up45 < ttgConvert.value.Upttg45 && colorFlag.value ? (_openBlock(), _createElementBlock("div", _hoisted_100, _toDisplayString(ttgConvert.value.Up45), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_101, _toDisplayString(ttgConvert.value.Up45), 1))]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_nut_row, null, {
        default: _withCtx(() => [_createVNode(_component_nut_col, {
          span: 4
        }, {
          default: _withCtx(() => [_hoisted_102]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 4
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_103, [_createVNode(_component_nut_trend_arrow, {
            rate: ttgConvert.value.Up05Rate
          }, null, 8, ["rate"])])]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 4
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_104, [_createVNode(_component_nut_trend_arrow, {
            rate: ttgConvert.value.Up15Rate
          }, null, 8, ["rate"])])]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 4
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_105, [_createVNode(_component_nut_trend_arrow, {
            rate: ttgConvert.value.Up25Rate
          }, null, 8, ["rate"])])]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 4
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_106, [_createVNode(_component_nut_trend_arrow, {
            rate: ttgConvert.value.Up35Rate
          }, null, 8, ["rate"])])]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 4
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_107, [_createVNode(_component_nut_trend_arrow, {
            rate: ttgConvert.value.Up45Rate
          }, null, 8, ["rate"])])]),
          _: 1
        })]),
        _: 1
      })], 64);
    };
  }
};